module.exports = import("https://cdn.jsdelivr.net/npm/mammoth@1.6.0/mammoth.browser.min.js");;